import ResourceService from "./resource.service";

class TripRouteService extends ResourceService {
  static get resource() {
    return "trip-route";
  }
}

export default TripRouteService;
